function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Orientation from './Orientation';
var Angle = /*#__PURE__*/function () {
  function Angle() {
    _classCallCheck(this, Angle);
    Angle.constructor_.apply(this, arguments);
  }
  return _createClass(Angle, [{
    key: "getClass",
    value: function getClass() {
      return Angle;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "toDegrees",
    value: function toDegrees(radians) {
      return radians * 180 / Math.PI;
    }
  }, {
    key: "normalize",
    value: function normalize(angle) {
      while (angle > Math.PI) angle -= Angle.PI_TIMES_2;
      while (angle <= -Math.PI) angle += Angle.PI_TIMES_2;
      return angle;
    }
  }, {
    key: "angle",
    value: function angle() {
      if (arguments.length === 1) {
        var p = arguments[0];
        return Math.atan2(p.y, p.x);
      } else if (arguments.length === 2) {
        var p0 = arguments[0];
        var p1 = arguments[1];
        var dx = p1.x - p0.x;
        var dy = p1.y - p0.y;
        return Math.atan2(dy, dx);
      }
    }
  }, {
    key: "isAcute",
    value: function isAcute(p0, p1, p2) {
      var dx0 = p0.x - p1.x;
      var dy0 = p0.y - p1.y;
      var dx1 = p2.x - p1.x;
      var dy1 = p2.y - p1.y;
      var dotprod = dx0 * dx1 + dy0 * dy1;
      return dotprod > 0;
    }
  }, {
    key: "isObtuse",
    value: function isObtuse(p0, p1, p2) {
      var dx0 = p0.x - p1.x;
      var dy0 = p0.y - p1.y;
      var dx1 = p2.x - p1.x;
      var dy1 = p2.y - p1.y;
      var dotprod = dx0 * dx1 + dy0 * dy1;
      return dotprod < 0;
    }
  }, {
    key: "interiorAngle",
    value: function interiorAngle(p0, p1, p2) {
      var anglePrev = Angle.angle(p1, p0);
      var angleNext = Angle.angle(p1, p2);
      return Math.abs(angleNext - anglePrev);
    }
  }, {
    key: "normalizePositive",
    value: function normalizePositive(angle) {
      if (angle < 0.0) {
        while (angle < 0.0) angle += Angle.PI_TIMES_2;
        if (angle >= Angle.PI_TIMES_2) angle = 0.0;
      } else {
        while (angle >= Angle.PI_TIMES_2) angle -= Angle.PI_TIMES_2;
        if (angle < 0.0) angle = 0.0;
      }
      return angle;
    }
  }, {
    key: "angleBetween",
    value: function angleBetween(tip1, tail, tip2) {
      var a1 = Angle.angle(tail, tip1);
      var a2 = Angle.angle(tail, tip2);
      return Angle.diff(a1, a2);
    }
  }, {
    key: "diff",
    value: function diff(ang1, ang2) {
      var delAngle = null;
      if (ang1 < ang2) {
        delAngle = ang2 - ang1;
      } else {
        delAngle = ang1 - ang2;
      }
      if (delAngle > Math.PI) {
        delAngle = 2 * Math.PI - delAngle;
      }
      return delAngle;
    }
  }, {
    key: "toRadians",
    value: function toRadians(angleDegrees) {
      return angleDegrees * Math.PI / 180.0;
    }
  }, {
    key: "getTurn",
    value: function getTurn(ang1, ang2) {
      var crossproduct = Math.sin(ang2 - ang1);
      if (crossproduct > 0) {
        return Angle.COUNTERCLOCKWISE;
      }
      if (crossproduct < 0) {
        return Angle.CLOCKWISE;
      }
      return Angle.NONE;
    }
  }, {
    key: "angleBetweenOriented",
    value: function angleBetweenOriented(tip1, tail, tip2) {
      var a1 = Angle.angle(tail, tip1);
      var a2 = Angle.angle(tail, tip2);
      var angDel = a2 - a1;
      if (angDel <= -Math.PI) return angDel + Angle.PI_TIMES_2;
      if (angDel > Math.PI) return angDel - Angle.PI_TIMES_2;
      return angDel;
    }
  }]);
}();
export { Angle as default };
Angle.constructor_ = function () {};
Angle.PI_TIMES_2 = 2.0 * Math.PI;
Angle.PI_OVER_2 = Math.PI / 2.0;
Angle.PI_OVER_4 = Math.PI / 4.0;
Angle.COUNTERCLOCKWISE = Orientation.COUNTERCLOCKWISE;
Angle.CLOCKWISE = Orientation.CLOCKWISE;
Angle.NONE = Orientation.COLLINEAR;